<template >
  <v-dialog v-model="openDialog" 
  max-width="18rem"
  width="18rem"
   
    transition="dialog-bottom-transition"
 >
  
<table class="tableStampa">
  <tr>
    <td><div style="width:100%;text-align:center">Stampa in corso ...</div></td>
    <td>
      <v-progress-circular v-show="started"  
      indeterminate></v-progress-circular>
    </td>
  </tr>
  
  <tr>
    <td colspan="2"><v-btn @click="annulla">Annulla</v-btn></td>
  </tr>
  
</table>


    

</v-dialog>

  
</template>
<script>
import { stampeService } from "../services/StampeServices.js";
import * as htmlToImage from 'html-to-image';
import { userService } from "../services/userServices.js";
export default {
  name: "Stampa",
  //props: ["rilievo","lpa","currentPrgComune","currentPrgAc"],

  data() {
    return {
      pdfName:'stampa',
        tipoStampa:'CIVICO',
        TS_CIVICO:'CIVICO',
        openDialog:false,
        pbStatus: { progress: 0, pbUid: "e5790351-0cda-49b9-8a87-d3a77f131db6" },
    loopTimeSingle: 12000,
      loopTimeTotal: 0,
      loopTimeMax: 4200000,
      started:false
    };
  },

  created() {
    this.$vuetify.theme.dark = true;
   },
  mounted() { },
  beforeMount() {

  },

  methods: {
    annulla(){
        this.stop();
        this.openDialog=false;
    },
    
    truncateDecimals(number, digits) {
      var multiplier = Math.pow(10, digits),
        adjustedNum = number * multiplier,
        truncatedNum = Math[adjustedNum < 0 ? "ceil" : "floor"](adjustedNum);

      return truncatedNum / multiplier;
    },
      
  stampaCivico(prgNe,node,pdfName) {
    this.tipoStampa=this.TS_CIVICO;
    this.pdfName=pdfName;
    this.openDialog=true;
    var _this=this;
   // var node=this.$refs.mappa.getMapDiv();
      htmlToImage.toJpeg(node).then(function (dataUrl) {
    //var img = new Image();
    //img.src = dataUrl;
    //document.body.appendChild(img);
    stampeService.printCivico(prgNe,dataUrl).then(
        (x) => {
          // alert('printAll'+JSON.stringify(x));
          _this.assignPbStatus(x);
          _this.startBuffer();
        },
        (y) => {
          _this.pbStatus.errFlg = 1;
          _this.pbStatus.exception = y;
          alert(JSON.stringify(_this.pbStatus));
          _this.$forceUpdate(); // Notice we have to use a $ he
        }
      );


  })
  .catch(function (error) {
    alert(JSON.stringify(error));
    //console.error('oops, something went wrong!', error);
  });


    
  },
  assignPbStatus(x) {
      this.pbStatus.progress = x.progress;
      this.pbStatus.compFlg = x.compFlg;
      this.pbStatus.annFlg = x.annFlg;
      this.pbStatus.errFlg = x.errFlg;
      this.pbStatus.exception = x.exception;
      this.pbStatus.des = x.des;
      this.pbStatus.title = x.title;
      this.pbStatus.pbUid = x.pbUid;
    },
    getPbStatus() {
      userService.getProgress(this.pbStatus.pbUid).then(
        (x) => {
          // alert(JSON.stringify(x));
          this.assignPbStatus(x);
          if (x.progress>0 && x.progress<0.01){
            var initStep=0.01;
            if (this.tipoStampa=="SELECTED_AC"){
              initStep=0.51;
            }
            this.progressPerc=initStep;//cosi si vede che è partito, i primi step sono sempre quelli più lenti
          }else{
            var progress=x.progress;
            if (this.tipoStampa=="SELECTED_AC" && progress<0.11){
              progress=0.51;
            }
          
          this.progressPerc = this.truncateDecimals(progress * 100, 1);
        }
          if (this.pbStatus.compFlg === 1) {
            this.downloadPb();
          }
        },
        (y) => {
          this.stop();
          this.pbStatus.errFlg = 1;
          this.pbStatus.exception = y;
        }
      );
    },
    stop() {
      this.started=false;
      clearInterval(this.pbInterval);
      this.pbInterval = 0;
      this.pbStatus.progress = 0;
      this.pbStatus.des = "";
      this.loopTimeTotal = 0;
    },
    downloadPb() {
      this.stop();
      var x = userService.downloadPb(this.pbStatus.pbUid,this.pdfName);
      // alert(JSON.stringify(x));
      var a = document.createElement("a");
      // a.href = window.URL.createObjectURL(x);
      a.href = x;
      a.download = this.pdfName;
      a.click();
      this.openDialog=false;
    },

    startBuffer() {
      this.stop();
      this.started=true;
      this.pbInterval = setInterval(() => {
        this.loopTimeTotal = this.loopTimeTotal + this.loopTimeSingle;

        this.getPbStatus();
        if (
          this.pbStatus.compFlg === 1 ||
          this.pbStatus.errFlg === 1 ||
          this.pbStatus.annFlg === 1 ||
          this.loopTimeTotal > this.loopTimeMax
        ) {
          this.stop();
        }
      }, this.loopTimeSingle);
    },
  },
};
</script>
<style scoped>
.tableStampa{
  background-color:black;

}
.tableStampa td{

  text-align: center;
  
  padding: 0px;;
}

</style>